export enum OperationType {
  Create = 1,
  Update = 2,
  Delete = 3,
}
